import { Button } from "antd";

type FormBuilderSaveAsDraftButtonProps = {
	form: any;
	text?: string;
	fieldsToWatch?: string[];
	handleFormSave: (data: any) => void;
	isLoading?: boolean;
};

const FormBuilderSaveAsDraftButton = ({
	form,
	fieldsToWatch,
	text = "Save as draft",
	handleFormSave,
	isLoading = false,
}: FormBuilderSaveAsDraftButtonProps) => {
	const handleClick = () => {
		if (fieldsToWatch && fieldsToWatch.length > 0) {
			const emptyField = fieldsToWatch.find(
				(field) =>
					form.formData?.[field] === "" ||
					form.formData?.[field] === undefined ||
					form.formData?.[field] === null
			);

			if (emptyField) {
				// Scroll to the empty field
				form.formRef.scrollToField(emptyField, {
					behavior: "smooth",
					block: "center",
				});

				// Highlight the field
				const fieldElement = document.querySelector(
					`[name="${emptyField}"], [id="${emptyField}"]`
				);
				if (fieldElement) {
					fieldElement.classList.add("custom-field-error");
					setTimeout(() => {
						fieldElement.classList.remove("custom-field-error");
					}, 3000);
				}
				return;
			}
		}

		handleFormSave(form.formData);
	};

	return (
		<Button htmlType="submit" disabled={isLoading} onClick={handleClick}>
			{text}
		</Button>
	);
};

export default FormBuilderSaveAsDraftButton;
